import { CompanyGroupsAdmin } from "@/features/admin/CompanyGroupsAdmin";
import { useAppShell } from "@/shell/app-shell-context";
import { isMaster } from "@/shared/utils/roles";

export function CompanyGroupsAdminRoute() {
  const { token, profile } = useAppShell();
  return <CompanyGroupsAdmin token={token} master={isMaster(profile)} />;
}
